//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
const RATIOS = {
  '1/1': '',
  '4/3': 'ri-4_3',
  '16/9': 'ri-16_9'
};
export default {
  name: 'MdmVideo',
  props: {
    image: {
      type: String,
      required: true
    },
    video: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'white'
    },
    withBackground: {
      type: Boolean,
      default: false
    },
    play: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: String,
      default: '16/9'
    },
    muted: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      playing: this.play
    };
  },

  computed: {
    currentVideo() {
      return "".concat(this.video, "?rel=0&amp;showinfo=0;0&autoplay=1");
    },

    youtube() {
      // regex for youtube videos
      // return this.video.includes('youtube');
      return this.video !== 'url-video-embed';
    }

  },
  methods: {
    playVideo() {
      if (this.youtube) {
        this.playing = true;
      }
    },

    stopVideo() {
      if (this.youtube) {
        this.playing = false;
      }
    },

    builderRatio(value) {
      return RATIOS[value];
    }

  }
};